var _circle, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadMultiImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "url(#paint0_linear_1606_849)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.7987 9.7765L58 8.58531L54.8724 7.4215L53.5993 4L52.358 7.33581L49 8.58531L52.4317 9.86219L53.5993 13L54.7987 9.7765Z",
    fill: "#BDC3C8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1606_849)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8011 59.3254L10.8038 59.0559L8.89403 59.0349C8.63515 59.0321 8.42738 58.8199 8.42995 58.5611L8.44865 56.6791L8.17911 56.6761L8.21651 52.9122L8.48604 52.9152L8.52344 49.1513L8.25391 49.1483L8.2913 45.3844L8.56084 45.3873L8.59824 41.6234L8.3287 41.6205L8.3661 37.8566L8.63563 37.8595L8.67303 34.0956L8.4035 34.0926L8.44089 30.3287L8.71043 30.3317L8.74783 26.5677L8.47829 26.5648L8.51569 22.8009L8.78522 22.8038L8.80392 20.9219C8.8065 20.663 9.01844 20.4554 9.27732 20.4583L11.1871 20.4792L11.1898 20.2096L15.0093 20.2515L15.0066 20.521L18.8262 20.5629L18.8288 20.2933L22.6484 20.3352L22.6457 20.6047L26.4652 20.6466L26.4679 20.377L30.2875 20.4189L30.2848 20.6884L34.1043 20.7302L34.107 20.4607L37.9265 20.5025L37.9238 20.7721L41.7434 20.8139L41.7461 20.5444L45.5656 20.5862L45.5629 20.8558L49.3825 20.8976L49.3851 20.6281L53.2047 20.6699L53.202 20.9395L55.1118 20.9604C55.3707 20.9632 55.5784 21.1754 55.5759 21.4343L55.5572 23.3162L55.8267 23.3192L55.7893 27.0831L55.5198 27.0801L55.4824 30.8441L55.7519 30.847L55.7145 34.6109L55.445 34.608L55.4076 38.3719L55.6771 38.3748L55.6397 42.1388L55.3702 42.1358L55.3328 45.8997L55.6023 45.9027L55.5649 49.6666L55.2954 49.6637L55.258 53.4276L55.5275 53.4305L55.4901 57.1944L55.2206 57.1915L55.2019 59.0734C55.1993 59.3323 54.9874 59.5399 54.7285 59.5371L52.8187 59.5161L52.816 59.7857L48.9965 59.7438L48.9992 59.4743L45.1796 59.4324L45.177 59.702L41.3574 59.6601L41.3601 59.3906L37.5406 59.3488L37.5379 59.6183L33.7183 59.5765L33.721 59.3069L29.9015 59.2651L29.8988 59.5346L26.0793 59.4928L26.082 59.2232L22.2624 59.1814L22.2597 59.4509L18.4402 59.4091L18.4429 59.1395L14.6233 59.0977L14.6207 59.3672L10.8011 59.3254Z",
    stroke: "#5E6974",
    strokeWidth: 0.539106,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1398 23.4035L9.81471 56.1179C9.81066 56.5257 10.1379 56.8598 10.5456 56.8643L53.0546 57.33C53.4623 57.3344 53.7962 57.0075 53.8002 56.5998L54.1253 23.8853C54.1293 23.4776 53.8021 23.1434 53.3943 23.139L10.8854 22.6733C10.4776 22.6688 10.1438 22.9957 10.1398 23.4035Z",
    fill: "#D4D9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.80935 56.8513L24.769 36.5945C25.0686 36.1886 25.678 36.1963 25.9675 36.6094L34.7687 49.1709L40.7173 42.7534C41.0214 42.4253 41.545 42.4409 41.8291 42.7864L53.7922 57.3359L9.80935 56.8513Z",
    fill: "#ADB9BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9664 33.3099C38.9454 35.2859 37.3785 36.8742 35.4678 36.8518C33.557 36.8295 32.0207 35.2085 32.0418 33.2325C32.0628 31.2564 33.6296 29.6681 35.5404 29.6905C37.4511 29.7129 38.9874 31.3338 38.9664 33.3099Z",
    fill: "#ADB9BF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1606_849",
    x1: 25.0115,
    y1: -108.874,
    x2: 32,
    y2: 89.5632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADB9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F4F6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1606_849"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.845,
    height: 39.8162,
    fill: "white",
    transform: "matrix(0.999993 -0.0038462 0.00390322 0.999992 8 20.1841)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadMultiImage);
export default __webpack_public_path__ + "static/media/upload-multi-image.aaabe5a8cea41ee96ba2e18b617b53bb.svg";
export { ForwardRef as ReactComponent };